import type { EvidenceItem } from "@swot/swot-components";
import { readBoolean, readDateIso, readString } from "./mapperUtils.js";

export function mapEvidenceItem(dto: unknown): EvidenceItem & { restricted?: boolean | undefined; quarantined?: boolean | undefined; externalVisible?: boolean | undefined } {
  const scanStatus = normalizeScanStatus(readString(dto, ["scanStatus", "malwareScanStatus"], "pending"));
  return {
    id: readString(dto, ["id", "evidenceId"], ""),
    fileName: readString(dto, ["fileName", "originalFileName", "storedFileName"], "Restricted or unnamed evidence"),
    evidenceType: readString(dto, ["evidenceType", "type"], "GENERAL"),
    uploadedBy: readString(dto, ["uploadedBy", "uploadedByUserId", "createdBy"], "Unknown"),
    uploadedAt: readDateIso(dto, ["uploadedAt", "uploadedAtUtc", "createdAtUtc"], ""),
    checksum: readString(dto, ["checksum", "sha256"], ""),
    scanStatus,
    retentionCode: readString(dto, ["retentionCode", "policyCode"], ""),
    restricted: readBoolean(dto, ["restricted", "visibilityRestricted"], false),
    quarantined: readBoolean(dto, ["quarantined"], scanStatus === "blocked"),
    externalVisible: readBoolean(dto, ["externalVisible"], false),
  };
}
function normalizeScanStatus(value: string): "pending" | "clean" | "blocked" {
  const v = value.toLowerCase();
  if (["clean", "passed", "approved"].includes(v)) return "clean";
  if (["blocked", "quarantined", "failed", "infected"].includes(v)) return "blocked";
  return "pending";
}
